export const ENGLISH_IQ_MILESTONES_SECONDS = [60, 180, 300, 600] as const;
